import { render, staticRenderFns } from "./captchaRecordList.vue?vue&type=template&id=624fc788"
import script from "./captchaRecordList.vue?vue&type=script&lang=js"
export * from "./captchaRecordList.vue?vue&type=script&lang=js"
import style0 from "./captchaRecordList.vue?vue&type=style&index=0&id=624fc788&lang=less"
import style1 from "./captchaRecordList.vue?vue&type=style&index=1&id=624fc788&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624fc788')) {
      api.createRecord('624fc788', component.options)
    } else {
      api.reload('624fc788', component.options)
    }
    module.hot.accept("./captchaRecordList.vue?vue&type=template&id=624fc788", function () {
      api.rerender('624fc788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customer/captchaRecordList.vue"
export default component.exports